<template>
  <Loader v-if="loader" />

  <prime-accordion class="box-operation-detail">
    <prime-accordion-tab>
      <template #header>
        <i class="pi pi-plus-circle"> </i>
        <span class="pl-1">Operazioni</span>
      </template>
      <div v-if="data.item.id">
        <span>
          <prime-button
            label="AGGIUNGI POD"
            icon="pi pi-directions"
            iconPos="right"
            class="p-button-secondary mr-3"
            @click="onAggiungiPod($event)"
          />
        </span>

        <span>
          <prime-button
            label="AGGIUNGI MASS. POD"
            icon="pi pi-directions"
            iconPos="right"
            class="p-button-secondary mr-3"
            @click="onAggiungiPodsMassivo($event)"
          />
        </span>

        <span>
          <prime-button
            label="AGGIUNGI PDR"
            icon="pi pi-directions"
            iconPos="right"
            class="p-button-secondary mr-3"
            @click="onAggiungiPdr($event)"
          />
        </span>

        <span>
          <prime-button
            label="ESPORTA MANDATO RID MPS"
            icon="pi pi-directions"
            iconPos="right"
            class="p-button-secondary mr-3"
            @click="onEsportaMandatoRid($event)"
          />
        </span>

        <span>
          <prime-button
            label="CHIUDI E CLONA CONTRATTO"
            icon="pi pi-directions"
            iconPos="right"
            class="p-button-secondary mr-3"
            @click="onClonaContratto($event)"
          />
        </span>

        <span>
          <prime-button
            label="ESPORTA SEDA"
            icon="pi pi-download"
            iconPos="right"
            class="p-button-secondary mr-3 mt-2"
            @click="onDownloadSeda($event)"
          />
        </span>
      </div>
    </prime-accordion-tab>
  </prime-accordion>

  <SupplyRiepilogoSection
    v-if="data.item.id"
    :cliente-id="data.item.info?.cod_cliente"
    :cliente-nome="data.item.info?.cliente"
    :saldo-residuo="contrattoSaldoResiduo"
    :supply-points="contrattoSupplyPoints"
    forniture-label="Forniture associate"
  />

  <prime-accordion :multiple="true" :activeIndex="[0]">
    <prime-accordion-tab>
      <template v-if="data.item.id" #header>
        <span>Dettagli</span>&nbsp;<span>{{ data.item.info.code }}</span>
      </template>

      <div v-if="data.item.id">
        <div class="formgrid grid">
          <div class="field col-12 md:col-4">
            <label for="cod_cliente">Cliente</label>
            <div id="cod_cleinte">
              <router-link
                :to="`/ask/clienti/${data.item.info.cod_cliente}/dettagli`"
                >{{ data.item.info.cliente }}</router-link
              >
            </div>
          </div>
          <div class="field col-12 md:col-4">
            <label for="cod_agente">Agente</label>
            <prime-dropdown
              id="cod_agente"
              v-model="data.item.info.cod_agente"
              :options="data.agenti"
              optionLabel="name"
              optionValue="id"
              placeholder="Seleziona agente..."
              :filter="true"
              :disabled="!infoIsInEdit"
              class="inputfield w-full"
              @update:modelValue="getScalaAgenti"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cod_agente_firmatario">Agente firmatario</label>
            <prime-tree
              v-model="data.item.key"
              :options="data.item.sottoAgenti"
              :filter="true"
              optionLabel="name"
              optionValue="id"
              placeholder="Seleziona un agente"
              class="w-full"
              :disabled="!infoIsInEdit"
              @update:modelValue="changeNode"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cod_type_acquisizione">Tipo Acquisizione</label>
            <prime-dropdown
              id="cod_type_acquisizione"
              v-model="data.item.info.cod_type_acquisizione"
              :options="data.tipiAcquisizione"
              optionLabel="name"
              optionValue="id"
              placeholder="Seleziona tipologia..."
              :disabled="!infoIsInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cod_type_contratto">Tipo contratto</label>
            <prime-dropdown
              id="cod_type_contratto"
              v-model="data.item.info.cod_type_contratto"
              :options="data.tipiContrattoVendita"
              optionLabel="name"
              optionValue="id"
              placeholder="Seleziona tipologia..."
              :disabled="!infoIsInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cod_type_fatturazione">Tipo Fatturazione</label>
            <prime-dropdown
              id="cod_type_fatturazione"
              v-model="data.item.info.cod_type_fatturazione"
              :options="data.tipiFatturazione"
              optionLabel="name"
              optionValue="id"
              placeholder="Seleziona tipologia..."
              :disabled="!infoIsInEdit"
              class="inputfield w-full"
            />
          </div>

          <div class="field col-12 md:col-4">
            <label for="data_firma">Data Firma</label>
            <prime-calendar
              id="data_firma"
              v-model="dataFirma"
              :showIcon="true"
              dateFormat="dd/mm/yy"
              :disabled="!infoIsInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cod_type_spedizione">Spedizione</label>
            <prime-dropdown
              id="cod_type_spedizione"
              v-model="data.item.info.cod_type_spedizione"
              :options="data.tipiSpedizione"
              optionLabel="name"
              optionValue="id"
              placeholder="Seleziona tipologia..."
              :disabled="!infoIsInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cod_type_periodo">Periodo Fatturazione</label>
            <prime-dropdown
              id="cod_type_periodo"
              v-model="data.item.info.cod_type_periodo"
              :options="data.tipiPeriodoFatturazione"
              optionLabel="name"
              optionValue="id"
              placeholder="Seleziona tipologia..."
              :disabled="!infoIsInEdit"
              class="inputfield w-full"
            />
          </div>

          <div class="field col-12 md:col-4">
            <label for="data_inizio">Data Inizio</label>
            <prime-calendar
              id="data_inizio"
              v-model="dataInizio"
              :showIcon="true"
              dateFormat="dd/mm/yy"
              :disabled="!infoIsInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cod_type_pay">Metodo Pagamento</label>
            <prime-dropdown
              id="cod_type_pay"
              v-model="data.item.info.cod_type_pay"
              :options="data.tipiMetodoPagamentoCliente"
              optionLabel="name"
              optionValue="id"
              placeholder="Seleziona tipologia..."
              :filter="true"
              :disabled="!infoIsInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cod_type_periodo">Scadenza (gg)</label>
            <prime-dropdown
              id="cod_type_periodo"
              v-model="data.item.info.cod_type_scadenza"
              :options="data.giorniScadenza"
              optionLabel="name"
              optionValue="id"
              placeholder="Seleziona tipologia..."
              :filter="true"
              :disabled="!infoIsInEdit"
              class="inputfield w-full"
            />
          </div>

          <div class="field col-12 md:col-4">
            <label for="data_fine">Data Fine</label>
            <prime-calendar
              id="data_fine"
              v-model="dataFine"
              :showIcon="true"
              dateFormat="dd/mm/yy"
              :disabled="!infoIsInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cod_type_iva">Aliquota IVA</label>
            <prime-dropdown
              id="cod_type_iva"
              v-model="data.item.info.cod_type_iva"
              :options="data.tipiAliquotaIva"
              optionLabel="name"
              optionValue="id"
              placeholder="Seleziona tipologia..."
              :disabled="!infoIsInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="cod_type_state_ctr">Stato</label>
            <prime-dropdown
              id="cod_type_state_ctr"
              v-model="data.item.info.stato"
              :options="data.tipiStatoContratto"
              optionLabel="name"
              optionValue="value"
              placeholder="Seleziona tipologia..."
              :filter="true"
              :disabled="!infoIsInEdit"
              class="inputfield w-full"
            />
            <prime-dropdown
              v-if="data.item.info.stato == 0"
              v-model="data.item.info.motivazione_stato"
              :options="data.motivazioniStatoContrattoKo"
              optionLabel="name"
              optionValue="id"
              placeholder="Seleziona motivazione..."
              :filter="true"
              :disabled="!infoIsInEdit"
              class="inputfield w-full"
            />
            <prime-input-text
              v-if="
                data.item.info.stato == 0 &&
                data.item.info.motivazione_stato == 4
              "
              v-model="data.item.info.motivazione_stato_testo"
              type="text"
              placeholder="Motivazione del ko..."
              :disabled="!infoIsInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="note">Note</label>
            <prime-textarea
              id="note"
              v-model="data.item.info.note"
              rows="3"
              :disabled="!infoIsInEdit"
              class="inputfield w-full"
            />
          </div>

          <div class="field col-12 md:col-4">
            <label for="cod_cliente">Listino</label>
            <div id="cod_cliente">
              <div v-if="id_offerta > 0">
                <router-link
                  :to="`/ask/offerte/listini/${data.item.info.cod_offerta}/dettagli`"
                  target="_blank"
                >
                  {{ data.item.info.offerta_name }}
                </router-link>
              </div>
              <div v-else>
                <prime-dropdown
                  v-model="data.item.info.cod_offerta"
                  :options="data.offerte"
                  optionLabel="name"
                  optionValue="id"
                  placeholder="Seleziona listino"
                  :filter="true"
                  :disabled="!infoIsInEdit"
                  class="inputfield w-full"
                />
                <!-- <Button label="Associa listino" class="mt-2" @click="associaListino" /> -->
              </div>
            </div>
          </div>
        </div>

        <div class="flex justify-content-end">
          <div class="" v-if="!infoIsInEdit">
            <prime-button
              icon="pi pi-pencil"
              class="p-button-rounded p-button-success mr-2"
              @click="onEditInfo"
            />
          </div>

          <div class="" v-if="infoIsInEdit">
            <prime-button
              icon="pi pi-times"
              class="p-button-rounded p-button-danger mr-2"
              @click="onAbortInfoEdit"
            />
            <prime-button
              icon="pi pi-check"
              class="p-button-rounded p-button-success mr-2"
              @click="onUpdateInfo"
            />
          </div>
        </div>
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab>
      <template v-if="data.item.id" #header>
        <span>Contatto</span>
      </template>

      <div
        v-if="
          data.item.contatti &&
          data.item.contatti.length > 0 &&
          data.item.contatti[0].cod_rapp > 0 &&
          data.item.contatti[0].cod_rapp != data.item.info.rappresentante_id
        "
      >
        <Message severity="warn" closable>
          Sembra che il rappresentante del cliente sia cambiato
        </Message>
      </div>

      <Card>
        <template #content>
          <div
            v-if="data.item.info?.rappresentante_id != null && data.item.rappresentante"
            class="mb-4"
          >
            <Message severity="info" :closable="false" class="mt-0">
              Il seguente contatto è del rappresentante associato al cliente.
            </Message>
            <div class="formgrid grid mt-3">
              <div class="field col-12 md:col-3">
                <label>Rappresentante</label>
                <div>{{ data.item.rappresentante.name || "N/A" }}</div>
              </div>
              <div class="field col-12 md:col-3">
                <label>Codice Fiscale</label>
                <div>{{ data.item.rappresentante.codfis || "N/A" }}</div>
              </div>
              <div class="field col-12 md:col-3">
                <label>Email</label>
                <div>{{ data.item.rappresentante.email || "N/A" }}</div>
              </div>
              <div class="field col-12 md:col-3">
                <label>PEC</label>
                <div>{{ data.item.rappresentante.pec || "N/A" }}</div>
              </div>
            </div>
          </div>

          <div v-if="data.item.contatti?.length">
            <div
              v-for="contatto in data.item.contatti"
              :key="contatto.id"
              class="contact-details"
            >
              <section class="contact-data-section">
                <h5><i class="pi pi-map-marker" aria-hidden="true"></i> Indirizzo</h5>
                <div class="formgrid grid">
                  <div class="field col-12 md:col-2">
                    <label>Toponimo</label>
                    <div>{{ contatto.toponimo || "Mancante" }}</div>
                  </div>
                  <div class="field col-12 md:col-4">
                    <label>Indirizzo</label>
                    <div>{{ contatto.indirizzo || "Mancante" }}</div>
                  </div>
                  <div class="field col-12 md:col-2">
                    <label>Civico</label>
                    <div>{{ contatto.civico || "Mancante" }}</div>
                  </div>
                  <div class="field col-12 md:col-2">
                    <label>CAP</label>
                    <div>{{ contatto.cap || "Mancante" }}</div>
                  </div>
                  <div class="field col-12 md:col-2">
                    <label>Comune</label>
                    <div>{{ contatto.comune || "Mancante" }}</div>
                  </div>
                </div>
              </section>

              <section class="contact-data-section">
                <h5><i class="pi pi-phone" aria-hidden="true"></i> Recapiti</h5>
                <div class="formgrid grid">
                  <div class="field col-12 md:col-3">
                    <label>Cellulare</label>
                    <div>{{ contatto.cell || "Mancante" }}</div>
                  </div>
                  <div class="field col-12 md:col-3">
                    <label>Email</label>
                    <div>{{ contatto.email || "Mancante" }}</div>
                  </div>
                  <div class="field col-12 md:col-2">
                    <label>Telefono Fisso</label>
                    <div>{{ contatto.tel || "Mancante" }}</div>
                  </div>
                  <div class="field col-12 md:col-2">
                    <label>PEC</label>
                    <div>{{ contatto.pec || "Mancante" }}</div>
                  </div>
                  <div class="field col-12 md:col-2">
                    <label>Fax</label>
                    <div>{{ contatto.fax || "Mancante" }}</div>
                  </div>
                </div>
              </section>

              <section class="contact-data-section">
                <h5><i class="pi pi-envelope" aria-hidden="true"></i> Invio email di accesso</h5>
                <div class="formgrid grid">
                  <div class="field col-12 md:col-4">
                    <label>Email Accesso Inviata</label>
                    <div>{{ contatto.access_email_sent ? "SI" : "NO" }}</div>
                  </div>
                  <div class="field col-12 md:col-4">
                    <label>Data</label>
                    <div>
                      {{
                        contatto.access_datetime_sent !== null
                          ? moment(contatto.access_datetime_sent).format("DD/MM/YYYY")
                          : "Mancante"
                      }}
                    </div>
                  </div>
                  <div class="field col-12 md:col-4">
                    <label>Ora</label>
                    <div>
                      {{
                        contatto.access_datetime_sent !== null
                          ? moment(contatto.access_datetime_sent).format("HH:mm:ss")
                          : "Mancante"
                      }}
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
          <div v-else>Nessun contatto associato.</div>
        </template>
      </Card>

      <div class="mt-4">
        <h4 class="mt-0 mb-3">Azioni</h4>
        <div class="flex flex-wrap gap-2">
          <prime-button
            v-if="data.item.info?.client_rapp_id == 0"
            label="Crea Nuovo Contatto"
            class="p-button-secondary"
            @click="dialogCreateNewContactCliente = true"
          />
          <prime-button
            label="Cambia contatto"
            class="p-button-secondary"
            @click="dialogNewContact = true"
          />
          <prime-button
            v-if="data.item.contatti?.[0]?.email"
            label="Invia email di accesso"
            icon="pi pi-send"
            iconPos="right"
            class="p-button-primary"
            @click="sendClientLoginEmail(data.item.contatti[0].email)"
          />
          <prime-button
            v-if="hasOtherContactAssociations(data.item.contatti?.[0])"
            label="Mostra altri contratti interessati"
            icon="pi pi-eye"
            class="p-button-info"
            @click="openContactAssociations(data.item.contatti[0])"
          />
        </div>
      </div>
      <prime-accordion v-if="data.item.id" class="mt-3" @tab-open="loadStoricoCambiContatto">
        <prime-accordion-tab header="Storico cambi contatto">
          <StoricoCambioAnagrafica kind="contatto" :entries="storicoCambiContatto" :loading="storicoCambiContattoLoading" :error="storicoCambiContattoError" />
        </prime-accordion-tab>
      </prime-accordion>
    </prime-accordion-tab>

    <prime-accordion-tab header="RID">
      <div v-if="data.item.id">
        <div class="formgrid grid">
          <div class="field col-12 md:col-4">
            <label for="iban">IBAN</label>
            <prime-input-text
              id="iban"
              v-model="data.item.rid.iban"
              type="text"
              :disabled="!ridIsInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="tipo_mandato">Tipo Mandato</label>
            <prime-input-text
              id="tipo_mandato"
              v-model="data.item.rid.tipo_mandato"
              type="text"
              :disabled="!ridIsInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="istituto">Banca</label>
            <prime-input-text
              id="istituto"
              v-model="data.item.rid.istituto"
              type="text"
              :disabled="!ridIsInEdit"
              class="inputfield w-full"
            />
          </div>

          <div class="p-field col-12 p-md-6">
            <label for="intestazione">Intestazione</label>
            <prime-input-text
              id="intestazione"
              v-model="data.item.rid.intestazione"
              type="text"
              :disabled="!ridIsInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="p-field col-12 p-md-6">
            <label for="cfintestazione">Codice Fiscale</label>
            <prime-input-text
              id="cfintestazione"
              v-model="data.item.rid.cfintestazione"
              type="text"
              :disabled="!ridIsInEdit"
              class="inputfield w-full"
            />
          </div>

          <div class="p-field col-12 p-md-6">
            <label for="cod_type_rid">Tipo RID</label>
            <prime-dropdown
              id="cod_type_rid"
              v-model="data.item.rid.cod_type_rid"
              :options="data.tipiRid"
              optionLabel="name"
              optionValue="id"
              placeholder="Seleziona tipologia..."
              :disabled="!ridIsInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="p-field col-12 p-md-6">
            <label for="data_firma_rid">Data Firma</label>
            <prime-calendar
              id="data_firma_rid"
              v-model="dataFirmaRid"
              :showIcon="true"
              dateFormat="dd/mm/yy"
              :disabled="!ridIsInEdit"
              class="inputfield w-full"
            />
          </div>
        </div>

        <div class="grid p-jc-end">
          <div class="col-12 text-right" v-if="!ridIsInEdit">
            <prime-button
              icon="pi pi-pencil"
              class="p-button-rounded p-button-success mr-2"
              @click="onEditRid"
            />
          </div>

          <div class="col-12 text-right" v-if="ridIsInEdit">
            <prime-button
              icon="pi pi-times"
              class="p-button-rounded p-button-danger mr-2"
              @click="onAbortRidEdit"
            />
            <prime-button
              icon="pi pi-check"
              class="p-button-rounded p-button-success mr-2"
              @click="onUpdateRid"
            />
          </div>
        </div>
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab>
      <template v-if="data.item.id" #header>
        <div>
          <span>Provvigioni Agente</span>&nbsp;<span>{{
            data.item.provvigioni_agente.agente_name
          }}</span>
        </div>
      </template>

      <div v-if="data.item.id">
        <div class="formgrid grid md:col-4">
          <div class="field col-12">
            <label for="cod_agente">Agente</label>
            <prime-dropdown
              id="cod_agente"
              v-model="data.item.provvigioni_agente.cod_agente"
              :options="data.agenti"
              optionLabel="name"
              optionValue="id"
              placeholder="Seleziona agente..."
              :filter="true"
              :disabled="!provvigioniAgenteIsInEdit"
              class="inputfield w-full"
            />
          </div>

          <div class="field col-12 md:col-4">
            <label for="ric_mens">Ricorrente mensile</label>
            <prime-input-text
              id="ric_mens"
              v-model="data.item.provvigioni_agente.ric_mens"
              type="text"
              :disabled="!provvigioniAgenteIsInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="ric_cons">Ricorrente per consumo</label>
            <prime-input-text
              id="ric_cons"
              v-model="data.item.provvigioni_agente.ric_cons"
              type="text"
              :disabled="!provvigioniAgenteIsInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-4">
            <label for="giorni_ric">Giorni per Ricorrente</label>
            <prime-input-text
              id="giorni_ric"
              v-model="data.item.provvigioni_agente.giorni_ric"
              type="text"
              :disabled="!provvigioniAgenteIsInEdit"
              class="inputfield w-full"
            />
          </div>

          <div class="field col-12 md:col-3">
            <label for="gettone1">Gettone 1 (Euro/Punto)</label>
            <prime-input-text
              id="gettone1"
              v-model="data.item.provvigioni_agente.gettone1"
              type="text"
              :disabled="!provvigioniAgenteIsInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-3">
            <label for="gettone1_consumo">Gettone 1 (Euro/Consumo)</label>
            <prime-input-text
              id="gettone1_consumo"
              v-model="data.item.provvigioni_agente.gettone1_consumo"
              type="text"
              :disabled="!provvigioniAgenteIsInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-3">
            <label for="giorni_gettone1">Giorni per Gettone 1</label>
            <prime-input-text
              id="giorni_gettone1"
              v-model="data.item.provvigioni_agente.giorni_gettone1"
              type="text"
              :disabled="!provvigioniAgenteIsInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-3">
            <label for="gettone1_stornabile">Stornabile</label>
            <div>
              <prime-checkbox
                id="gettone1_stornabile"
                v-model="data.item.provvigioni_agente.gettone1_stornabile"
                :binary="true"
                :disabled="!provvigioniAgenteIsInEdit"
                class="inputfield w-full"
              />
            </div>
          </div>

          <div class="field col-12 md:col-3">
            <label for="gettone2">Gettone 2 (Euro/Punto)</label>
            <prime-input-text
              id="gettone2"
              v-model="data.item.provvigioni_agente.gettone2"
              type="text"
              :disabled="!provvigioniAgenteIsInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-3">
            <label for="gettone2_consumo">Gettone 2 (Euro/Consumo)</label>
            <prime-input-text
              id="gettone2_consumo"
              v-model="data.item.provvigioni_agente.gettone2_consumo"
              type="text"
              :disabled="!provvigioniAgenteIsInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-3">
            <label for="giorni_gettone2">Giorni per Gettone 2</label>
            <prime-input-text
              id="giorni_gettone2"
              v-model="data.item.provvigioni_agente.giorni_gettone2"
              type="text"
              :disabled="!provvigioniAgenteIsInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-3">
            <label for="gettone2_stornabile">Stornabile</label>
            <div>
              <prime-checkbox
                id="gettone2_stornabile"
                v-model="data.item.provvigioni_agente.gettone2_stornabile"
                :binary="true"
                :disabled="!provvigioniAgenteIsInEdit"
                class="inputfield w-full"
              />
            </div>
          </div>

          <div class="field col-12 md:col-3">
            <label for="gettone3">Gettone 3 (Euro/Punto)</label>
            <prime-input-text
              id="gettone3"
              v-model="data.item.provvigioni_agente.gettone3"
              type="text"
              :disabled="!provvigioniAgenteIsInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-3">
            <label for="gettone3_consumo">Gettone 3 (Euro/Consumo)</label>
            <prime-input-text
              id="gettone3_consumo"
              v-model="data.item.provvigioni_agente.gettone3_consumo"
              type="text"
              :disabled="!provvigioniAgenteIsInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-3">
            <label for="giorni_gettone3">Giorni per Gettone 3</label>
            <prime-input-text
              id="giorni_gettone3"
              v-model="data.item.provvigioni_agente.giorni_gettone3"
              type="text"
              :disabled="!provvigioniAgenteIsInEdit"
              class="inputfield w-full"
            />
          </div>
          <div class="field col-12 md:col-3">
            <label for="gettone3_stornabile">Stornabile</label>
            <div>
              <prime-checkbox
                id="gettone3_stornabile"
                v-model="data.item.provvigioni_agente.gettone3_stornabile"
                :binary="true"
                :disabled="!provvigioniAgenteIsInEdit"
                class="inputfield w-full"
              />
            </div>
          </div>
        </div>

        <div class="grid p-jc-end">
          <div class="col-12 text-right" v-if="!provvigioniAgenteIsInEdit">
            <prime-button
              icon="pi pi-pencil"
              class="p-button-rounded p-button-success mr-2"
              @click="onEditProvvigioniAgente"
            />
          </div>

          <div class="col-12 text-right" v-if="provvigioniAgenteIsInEdit">
            <prime-button
              icon="pi pi-times"
              class="p-button-rounded p-button-danger mr-2"
              @click="onAbortProvvigioniAgenteEdit"
            />
            <prime-button
              icon="pi pi-check"
              class="p-button-rounded p-button-success mr-2"
              @click="onUpdateProvvigioniAgente"
            />
          </div>
        </div>
      </div>
    </prime-accordion-tab>

    <prime-accordion-tab header="Documentazione">
      <prime-accordion>
        <prime-accordion-tab header="Aggiungi un nuovo file">
          <div class="formgrid grid form-documents">
            <div class="field col-12 md:col-3">
              <div class="button-wrapper">
                <span class="label">{{
                  data.allegato.file.length == 0
                    ? "Seleziona File"
                    : data.allegato.file.length == 1
                    ? data.allegato.file[0].name
                    : data.allegato.file.length + " files"
                }}</span>
                <input
                  id="upload"
                  type="file"
                  @change="handleFileUpload($event)"
                  accept="application/pdf,image/gif, image/jpeg, image/jpg,image/png"
                  multiple
                />
              </div>
              <div v-show="validationErrors.files && submitted" class="p-error">
                Campo richiesto.
              </div>
              <div v-show="validationErrors.type && submitted" class="p-error">
                Formato non consentito
              </div>
            </div>
            <div class="field col-12 md:col-3">
              <prime-dropdown
                class="inputfield w-full"
                v-model="data.allegato.tipo"
                :options="data.tipiAllegato"
                optionLabel="name"
                optionValue="id"
                placeholder="Seleziona tipologia..."
              />
              <div v-show="validationErrors.tipo && submitted" class="p-error">
                Campo richiesto.
              </div>
            </div>
            <div class="field col-12 md:col-3">
              <prime-textarea
                class="inputfield w-full"
                v-model="data.allegato.note"
                rows="1"
                placeholder="Inserisci note..."
              />
            </div>
            <div class="field col-12 md:col-3">
              <prime-button
                @click="uploadDocumenti"
                class="w-full"
                label="Carica"
                icon="pi pi-upload"
                iconPos="right"
              />
            </div>
          </div>
        </prime-accordion-tab>

        <prime-accordion-tab
          header="File Caricati"
          v-if="data.item.allegati && data.item.allegati.length > 0"
        >
          <prime-data-table
            :value="data.item.allegati"
            responsiveLayout="scroll"
          >
            <prime-column field="name" header="File" :sortable="true">
              <template #body="{ data }">
                <div v-if="data.name">
                  {{ data.name.split("/").reverse()[0] }}
                </div>
              </template>
            </prime-column>
            <prime-column
              field="tipo"
              header="Tipo"
              :sortable="true"
            ></prime-column>
            <prime-column
              field="date_creation"
              header="Data Caricamento"
              :sortable="true"
            ></prime-column>
            <prime-column :exportable="false">
              <template #body="{ data }">
                <div v-if="data.path == '' || data.path == null">
                  <Button
                    icon="pi pi-download"
                    class="p-button-rounded p-button-success mr-2"
                    @click="downloadDocumenti(data)"
                  />
                </div>
              </template>
            </prime-column>
            <prime-column :exportable="false">
              <template #body="{ data }">
                <div v-if="data.path == '' || data.path == null">
                  <Button
                    icon="pi pi-eye"
                    class="p-button-rounded p-button-success mr-2"
                    @click="openDocumenti(data)"
                  />
                </div>
                <!-- else is google drive link -->
                <div v-else>
                  <a :href="`${data.path}`" target="_blank">
                    <Button
                      icon="pi pi-eye"
                      class="p-button-rounded p-button-success mr-2"
                    />
                  </a>
                </div>
              </template>
            </prime-column>
          </prime-data-table>
        </prime-accordion-tab>

        <prime-accordion-tab
          v-if="
            data.item.allegati_wizard && data.item.allegati_wizard.length > 0
          "
        >
          <template #header>
            <div class="flex">
              File da wizard - caricamento #{{
                data.item.allegati_wizard[0].matrice_id
              }}
            </div>
          </template>
          <prime-data-table
            :value="data.item.allegati_wizard"
            responsiveLayout="scroll"
          >
            <prime-column field="filename" header="File" :sortable="true" />
            <prime-column
              field="name"
              header="Tipo"
              :sortable="true"
            ></prime-column>
            <prime-column
              field="data_creazione"
              header="Data Caricamento"
              :sortable="true"
            >
              <template #body="{ data }">
                {{ moment(data.data_creazione).format("DD-MM-Y H:m:s") }}
              </template>
            </prime-column>
            <prime-column :exportable="false">
              <template #body="{ data }">
                <Button
                  icon="pi pi-download"
                  class="p-button-rounded p-button-success mr-2"
                  @click="
                    downloadDocumento_wizard(data.matrice_id, data.filename)
                  "
                />
              </template>
            </prime-column>
            <prime-column :exportable="false">
              <template #body="{ data }">
                <Button
                  icon="pi pi-eye"
                  class="p-button-rounded p-button-success mr-2"
                  @click="openDocumento_wizard(data.matrice_id, data.filename)"
                />
              </template>
            </prime-column>
          </prime-data-table>
        </prime-accordion-tab>
      </prime-accordion>
    </prime-accordion-tab>

    <prime-accordion-tab header="POD">
      <prime-data-table
        :paginator="true"
        :rows="10"
        :rowsPerPageOptions="[10, 25, 50]"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
        :value="data.item.pods"
        responsiveLayout="scroll"
      >
        <prime-column field="code" header="POD"></prime-column>
        <prime-column field="indirizzo" header="Indirizzo"></prime-column>
        <prime-column field="" header="Comune" :sortable="true">
          <template #body="{ data }">
            <span>
              {{ `${data.comune} (${data.provincia})` }}
            </span>
          </template>
        </prime-column>
        <prime-column field="" header="Potenza">
          <template #body="{ data }">
            <span>
              {{ `${floatFixFormatter.format(data.potenza_impegnata)}` }}
            </span>
          </template>
        </prime-column>
        <prime-column
          field="tensione"
          header="Tensione"
          :sortable="true"
        ></prime-column>
        <prime-column field="" header="Data Inizio" :sortable="true">
          <template #body="{ data }">
            {{
              data.data_inizio !== null
                ? moment(data.data_inizio).format("DD/MM/YYYY")
                : ""
            }}
          </template>
        </prime-column>
        <prime-column field="" header="Data Fine" :sortable="true">
          <template #body="{ data }">
            {{
              data.data_fine !== null
                ? moment(data.data_fine).format("DD/MM/YYYY")
                : ""
            }}
          </template>
        </prime-column>
      </prime-data-table>
    </prime-accordion-tab>

    <prime-accordion-tab header="PDR">
      <prime-data-table
        :paginator="true"
        :rows="10"
        :rowsPerPageOptions="[10, 25, 50]"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
        :value="data.item.pdrs"
        responsiveLayout="scroll"
      >
        <prime-column field="code" header="PDR"></prime-column>
        <prime-column field="indirizzo" header="Indirizzo"></prime-column>
        <prime-column field="" header="Comune" :sortable="true">
          <template #body="{ data }">
            <span>
              {{ `${data.comune} (${data.provincia})` }}
            </span>
          </template>
        </prime-column>
        <prime-column field="" header="Potenza">
          <template #body="{ data }">
            <span>
              {{ `${floatFixFormatter.format(data.potenza_impegnata)}` }}
            </span>
          </template>
        </prime-column>
        <prime-column field="" header="Data Inizio" :sortable="true">
          <template #body="{ data }">
            {{
              data.data_inizio !== null
                ? moment(data.data_inizio).format("DD/MM/YYYY")
                : ""
            }}
          </template>
        </prime-column>
        <prime-column field="" header="Data Fine" :sortable="true">
          <template #body="{ data }">
            {{
              data.data_fine !== null
                ? moment(data.data_fine).format("DD/MM/YYYY")
                : ""
            }}
          </template>
        </prime-column>
      </prime-data-table>
    </prime-accordion-tab>

    <prime-accordion-tab>
      <template v-if="data.item.id" #header>
        <span
          >Estratto Conto ({{
            currencyFormatter.format(
              isNaN(data.item.fatture.saldo)
                ? 0
                : data.item.fatture.saldo !== null
                ? data.item.fatture.saldo
                : 0
            )
          }})</span
        >
      </template>

      <prime-data-table
        v-if="data.item.id"
        :paginator="true"
        :rows="10"
        :rowsPerPageOptions="[10, 25, 50]"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="{first} a {last} di {totalRecords} elementi"
        :value="data.item.fatture.dettagli"
        responsiveLayout="scroll"
      >
        <prime-column field="numero" header="Numero Fattura"></prime-column>
        <prime-column field="cliente" header="Cliente"></prime-column>
        <prime-column field="" header="Data Emissione" :sortable="true">
          <template #body="{ data }">
            {{
              data.data_emissione !== null
                ? moment(data.data_emissione).format("DD/MM/YYYY")
                : ""
            }}
          </template>
        </prime-column>
        <prime-column field="" header="Mese Fatturazione" :sortable="true">
          <template #body="{ data }">
            <!-- {{ `${data.mese_fatturazione.split('-')}` }} -->
            {{
              `${months[parseInt(data.mese_fatturazione.split("-")[1]) - 1]} ${
                data.mese_fatturazione.split("-")[0]
              }`
            }}
          </template>
        </prime-column>
        <prime-column field="stato" header="Stato"></prime-column>
        <prime-column field="" header="Importo Fattura">
          <template #body="{ data }">
            {{
              currencyFormatter.format(data.importo !== null ? data.importo : 0)
            }}
          </template>
        </prime-column>
        <prime-column field="" header="Importo Pagato">
          <template #body="{ data }">
            {{
              currencyFormatter.format(data.pagato !== null ? data.pagato : 0)
            }}
          </template>
        </prime-column>
        <prime-column field="" header="Saldo">
          <template #body="{ data }">
            {{ currencyFormatter.format(data.saldo !== null ? data.saldo : 0) }}
          </template>
        </prime-column>
      </prime-data-table>
    </prime-accordion-tab>
  </prime-accordion>

  <!-- Dialog inserimento massivo pods -->
  <Dialog
    header="Inserimento massivo pods"
    v-model:visible="dialogPodsMassivo"
    :style="{ width: '60vw' }"
  >
    <div
      class="flex align-items-center flex-column align-items-center"
      style="100vh"
    >
      <div class="button-wrapper mb-2">
        <span class="label">{{
          fileCsv.length > 0 ? fileCsv[0].name : "Carica File"
        }}</span>
        <input
          id="upload"
          type="file"
          ref="file"
          @change="handleCsvUpload($event)"
          accept=".csv"
        />
      </div>
      <div v-show="validationErrors.files && submitted" class="p-error">
        Campo richiesto.
      </div>
      <div v-show="validationErrors.type && submitted" class="p-error">
        Formato non consentito
      </div>
    </div>
    <div class="text-center">
      <small>Formati consentiti: {{ allowedType.join(", ") }}</small>
    </div>

    <template #footer>
      <Button
        label="Annulla"
        icon="pi pi-times"
        @click="dialogPodsMassivo = false"
        class="p-button-text"
      />
      <Button
        label="Inserisci"
        icon="pi pi-check"
        @click="createPodsMassivo"
        autofocus
      />
    </template>
  </Dialog>
  <!-- Dialog inserimento massivo pods -->

  <!-- Dialog cambio contatto -->
  <Dialog
    header="Cambio contatto"
    modal
    v-model:visible="dialogNewContact"
    class="change-contact-dialog"
    :style="{ width: '80vw', height: '85vh', maxHeight: '85vh', background: 'var(--surface-overlay)' }"
    :contentStyle="{ flex: '1 1 auto', minHeight: 0, overflowY: 'auto', background: 'var(--surface-overlay)' }"
  >
    <div class="grid mt-3">
      <div class="field col-12 md:col-7">
        <Dropdown
          v-model="data.newContatto.exist"
          :options="data.item.contattiall"
          optionLabel="dropdown_label"
          optionDisabled="disabled_duplicate"
          :filter="true"
          scrollHeight="21rem"
          placeholder="Seleziona contatto"
          class="w-full"
        >
          <template #value="slotProps">
            <div v-if="slotProps.value && slotProps.value.id" class="change-contact-option change-contact-option-selected">
              <div class="change-contact-option-header">
                <span
                  class="change-contact-owner"
                  :class="{ 'change-contact-owner-representative': isRepresentativeContact(slotProps.value) }"
                >
                  <i class="pi pi-user" aria-hidden="true"></i>
                  {{ contactOwnerLabel(slotProps.value) }}
                </span>
              </div>
              <strong class="change-contact-address">{{ contactAddressLabel(slotProps.value) }}</strong>
              <div class="change-contact-recapiti">
                <span><i class="pi pi-envelope" aria-hidden="true"></i>Email: {{ contactDisplayValue(slotProps.value.email) }}</span>
                <span><i class="pi pi-at" aria-hidden="true"></i>PEC: {{ contactDisplayValue(slotProps.value.pec) }}</span>
                <span><i class="pi pi-mobile" aria-hidden="true"></i>Cellulare: {{ contactDisplayValue(slotProps.value.cell) }}</span>
              </div>
            </div>
            <span v-else>
              {{ slotProps.placeholder }}
            </span>
          </template>
          <template #option="slotProps">
            <div class="change-contact-option" :class="{ 'change-contact-option-duplicate': slotProps.option.disabled_duplicate }">
              <div class="change-contact-option-header">
                <span
                  class="change-contact-owner"
                  :class="{ 'change-contact-owner-representative': isRepresentativeContact(slotProps.option) }"
                >
                  <i class="pi pi-user" aria-hidden="true"></i>
                  {{ contactOwnerLabel(slotProps.option) }}
                </span>
                <div class="flex align-items-center gap-2">
                  <span v-if="slotProps.option.disabled_duplicate" class="change-contact-duplicate-label">
                    Duplicato di #{{ slotProps.option.duplicate_of }}
                  </span>
                  <small>#{{ slotProps.option.id }}</small>
                </div>
              </div>
              <strong class="change-contact-address">{{ contactAddressLabel(slotProps.option) }}</strong>
              <div class="change-contact-recapiti">
                <span><i class="pi pi-envelope" aria-hidden="true"></i>Email: {{ contactDisplayValue(slotProps.option.email) }}</span>
                <span><i class="pi pi-at" aria-hidden="true"></i>PEC: {{ contactDisplayValue(slotProps.option.pec) }}</span>
                <span><i class="pi pi-mobile" aria-hidden="true"></i>Cellulare: {{ contactDisplayValue(slotProps.option.cell) }}</span>
              </div>
            </div>
          </template>
        </Dropdown>
        <Message
          v-if="data.item.contattiall.some((contact) => contact.disabled_duplicate)"
          severity="warn"
          :closable="false"
          class="mt-2"
        >
          I contatti indicati come duplicati sono copie di un contatto originale e non possono essere selezionati.
        </Message>
      </div>
      <div class="field col-12 md:col-5">
        <div class="field-radiobutton">
          <RadioButton value="single" v-model="data.newContatto.type_update" />
          <label>Solo a questo contratto</label>
        </div>
        <div class="field-radiobutton" v-if="data.item.contatti.length > 0">
          <RadioButton value="all" v-model="data.newContatto.type_update" />
          <label
            >A tutti i contratti che hanno il vecchio contatto (id:{{
              data.item.contatti[0].id
            }}): {{ data.item.contatti[0].toponimo }}
            {{ data.item.contatti[0].indirizzo }},
            {{ data.item.contatti[0].civico }} -
            {{ data.item.contatti[0].comune }}
            {{ data.item.contatti[0].cap }}</label
          >
          <small class="p-error mt-1 pl-2"
            >Verranno modificati
            {{ data.item.info.n_contatti_uguali }} contratti</small
          >
        </div>
      </div>
      <div v-if="data.newContatto.type_update === 'all'" class="col-12">
        <ContactAssociationsDisplay
          v-if="data.item.contatti?.[0]?.contratti?.length"
          :contact="{ contratti: data.item.contatti[0].contratti }"
          contracts-header="Contratti che verranno modificati"
          :current-client-id="data.item.info.cod_cliente"
        />
        <Message v-else severity="warn" :closable="false">
          Nessun contratto associato al vecchio contatto.
        </Message>
      </div>
    </div>

    <template #footer>
      <Button
        label="Annulla"
        icon="pi pi-times"
        @click="dialogNewContact = false"
        class="p-button-text"
      />
      <Button
        :disabled="Object.keys(data.newContatto.exist).length == 0"
        label="Cambia"
        icon="pi pi-check"
        @click="updateNewContact"
        autofocus
      />
    </template>
  </Dialog>
  <!-- Dialog cambio contatto -->

  <!-- Dialog nuovo contatto -->
  <Dialog
    header="Crea Nuovo Contatto"
    modal
    v-model:visible="dialogCreateNewContactCliente"
    :style="{ width: '50vw' }"
  >
    <div class="grid mt-3">
      <div class="field col-12 md:col-2">
        <label for="toponimo">Toponimo</label>
        <PrimeDropdown
          id="toponimo"
          v-model="createNewContactCliente.toponimo"
          :options="toponimi"
          optionLabel="name"
          optionValue="name"
          placeholder="Seleziona Toponimo"
          class="w-full"
          :filter="true"
        />
        <small v-if="createNewContactCliente.toponimo && newContactClienteValidationErrors.toponimo" class="p-error">
          {{ newContactClienteValidationErrors.toponimo }}
        </small>
      </div>
      <div class="field col-12 md:col-6">
        <label for="indirizzo">Indirizzo</label>
        <PrimeInputText
          id="indirizzo"
          v-model="createNewContactCliente.indirizzo"
          placeholder="Inserisci Indirizzo"
          class="w-full"
        />
      </div>
      <div class="field col-12 md:col-4">
        <label for="civico">Civico</label>
        <PrimeInputText
          id="civico"
          v-model="createNewContactCliente.civico"
          placeholder="Inserisci Civico"
          class="w-full"
        />
      </div>
      <div class="field col-12 md:col-6">
        <label for="comune">Comune</label>
        <PrimeDropdown
          id="comune"
          v-model="createNewContactCliente.comune"
          :options="cities"
          optionLabel="label"
          optionValue="id"
          placeholder="Seleziona Comune"
          class="w-full"
          :filter="true"
          :loading="loadingCities"
          dataKey="id"
          @change="onChangeCreateNewContactComune"
        />
      </div>
      <div class="field col-12 md:col-3">
        <label for="cap">CAP</label>
        <div v-if="createNewContactCapSettings.isWildcard" class="multicap-editor w-full">
          <span class="multicap-prefix" title="Prefisso CAP del comune">
            {{ createNewContactCapSettings.prefix }}
          </span>
          <PrimeInputText
            id="cap"
            :modelValue="createNewContactCapSuffix"
            maxlength="2"
            inputmode="numeric"
            placeholder="00"
            class="multicap-suffix flex-1"
            @update:modelValue="updateCreateNewContactCapSuffix"
          />
        </div>
        <PrimeInputText
          v-else
          id="cap"
          v-model="createNewContactCliente.cap"
          placeholder="Inserisci CAP"
          class="w-full"
          :disabled="!createNewContactCapSettings.comune || createNewContactCapSettings.isFixed"
          maxlength="5"
          inputmode="numeric"
        />
        <small
          v-if="String(createNewContactCliente.cap || '').length === 5 && newContactClienteValidationErrors.cap"
          class="p-error"
        >
          {{ newContactClienteValidationErrors.cap }}
        </small>
      </div>
      <div class="field col-12 md:col-3">
        <label for="telefono">Telefono</label>
        <PrimeInputText
          id="telefono"
          v-model="createNewContactCliente.telefono"
          placeholder="Inserisci Telefono"
          class="w-full"
        />
      </div>
      <div class="field col-12 md:col-4">
        <label for="cellulare">Cellulare</label>
        <PrimeInputText
          id="cellulare"
          v-model="createNewContactCliente.cellulare"
          placeholder="Inserisci Cellulare"
          class="w-full"
        />
        <small v-if="createNewContactCliente.cellulare && newContactClienteValidationErrors.cellulare" class="p-error">
          {{ newContactClienteValidationErrors.cellulare }}
        </small>
      </div>
      <div class="field col-12 md:col-4">
        <label for="fax">Fax</label>
        <PrimeInputText
          id="fax"
          v-model="createNewContactCliente.fax"
          placeholder="Inserisci Fax"
          class="w-full"
        />
      </div>
      <div class="field col-12 md:col-4">
        <label for="pec">PEC</label>
        <PrimeInputText
          id="pec"
          v-model="createNewContactCliente.pec"
          placeholder="Inserisci PEC"
          class="w-full"
        />
        <small v-if="createNewContactCliente.pec && newContactClienteValidationErrors.pec" class="p-error">
          {{ newContactClienteValidationErrors.pec }}
        </small>
      </div>
      <div class="field col-12">
        <label for="email">Email</label>
        <PrimeInputText
          id="email"
          v-model="createNewContactCliente.email"
          placeholder="Inserisci Email"
          class="w-full"
        />
        <small v-if="createNewContactCliente.email && newContactClienteValidationErrors.email" class="p-error">
          {{ newContactClienteValidationErrors.email }}
        </small>
      </div>
    </div>

    <template #footer>
      <PrimeButton
        label="Annulla"
        icon="pi pi-times"
        @click="dialogCreateNewContactCliente = false"
        class="p-button-text"
      />
      <span v-tooltip.top="newContactClienteValidationTooltip">
        <PrimeButton
          label="Crea Contatto"
          icon="pi pi-check"
          @click="createNewContactClienteAction"
          class="p-button-primary"
          :disabled="!isValidCreateNewContactCliente"
        />
      </span>
    </template>
  </Dialog>
  <!-- Fine Dialog nuovo contatto -->

  <Dialog
    v-model:visible="duplicateNewContactDialog.visible"
    header="Contatto già esistente"
    modal
    :style="{ width: '34rem', maxWidth: '95vw' }"
  >
    <Message severity="warn" :closable="false" class="mt-0">
      Il contatto che stai tentando di creare esiste già. Non è possibile creare un duplicato: utilizza “Cambia contatto” per associarlo al contratto.
    </Message>
    <div v-if="duplicateNewContactDialog.contact" class="duplicate-new-contact-summary">
      <div><span>ID contatto</span><strong>#{{ duplicateNewContactDialog.contact.id }}</strong></div>
      <div><span>Indirizzo</span><strong>{{ contactAddressLabel(duplicateNewContactDialog.contact) }}</strong></div>
      <div><span>Email</span><strong>{{ contactDisplayValue(duplicateNewContactDialog.contact.email) }}</strong></div>
      <div><span>PEC</span><strong>{{ contactDisplayValue(duplicateNewContactDialog.contact.pec) }}</strong></div>
      <div><span>Cellulare</span><strong>{{ contactDisplayValue(duplicateNewContactDialog.contact.cell) }}</strong></div>
    </div>
    <template #footer>
      <PrimeButton label="Chiudi" icon="pi pi-times" class="p-button-text" @click="duplicateNewContactDialog.visible = false" />
      <PrimeButton label="Vai a Cambia contatto" icon="pi pi-arrow-right" @click="openChangeContactFromDuplicate" />
    </template>
  </Dialog>

  <ContactImpactDialog
    v-model="contactAssociationsDialog.visible"
    header="Altri contratti e caricamenti associati al contatto"
    :contact="contactAssociationsDialog.contact"
    contracts-header="Altri contratti interessati"
  />
</template>

<script>
import { wizard } from "@/config/sites";

import ContrattiVenditaService from "@/services/ask-management/contratti-vendita-service";
import UtilityService from "@/services/ask-management/utility-service";
import UtilityContrattiVenditaService from "@/services/ask-management/utility-contratti-vendita-service";
import CheckRcuService from "@/services/ask-management/CheckRcu";
import Loader from "@/components/Loader.vue";
import SupplyRiepilogoSection from "@/components/ask/details/SupplyRiepilogoSection.vue";
import ContactAssociationsDisplay from "@/components/ask/details/ContactAssociationsDisplay.vue";
import ContactImpactDialog from "@/components/ask/details/ContactImpactDialog.vue";
import StoricoCambioAnagrafica from "@/components/ask/details/StoricoCambioAnagrafica.vue";
import CambioRappresentanteService from "@/services/ask-pratiche/cambio-rappresentante";
import PrimeButton from "primevue/button";
import PrimeCalendar from "primevue/calendar";
import PrimeCheckbox from "primevue/checkbox";
import PrimeDropdown from "primevue/dropdown";
import PrimeAccordion from "primevue/accordion";
import PrimeAccordionTab from "primevue/accordiontab";
import PrimeInputText from "primevue/inputtext";
import PrimeTextarea from "primevue/textarea";
import PrimeDataTable from "primevue/datatable";
import PrimeColumn from "primevue/column";
import PrimeTree from "primevue/treeselect";

import moment from "moment";

export default {
  name: "ViewAskContrattiVenditaDetail",
  components: {
    PrimeButton,
    PrimeCalendar,
    PrimeCheckbox,
    PrimeDropdown,
    PrimeAccordion,
    PrimeAccordionTab,
    PrimeInputText,
    PrimeTextarea,
    PrimeDataTable,
    PrimeColumn,
    PrimeTree,
    SupplyRiepilogoSection,
    ContactAssociationsDisplay,
    ContactImpactDialog,
    StoricoCambioAnagrafica,
    Loader,
  },

  data() {
    return {
      moment,
      loader: false,
      storicoCambiContatto: [],
      storicoCambiContattoLoading: false,
      storicoCambiContattoError: '',
      storicoCambiContattoLoadedId: null,
      dialogPodsMassivo: false,
      dialogNewContact: false,
      fileCsv: [],
      allowedType: ["csv"],
      validationErrors: {},
      submitted: false,
      editingField: null,
      newFieldValue: "",
      editingEmail: null,
      newEmail: "",
      toponimi: [],
      createNewContactCliente: {
        toponimo: null,
        indirizzo: "",
        civico: "",
        cap: "",
        comune: null,
        telefono: "",
        cellulare: "",
        fax: "",
        pec: "",
        email: "",
      },
      dialogCreateNewContactCliente: false,
      duplicateNewContactDialog: {
        visible: false,
        contact: null,
      },
      contactAssociationsDialog: {
        visible: false,
        contact: { contratti: [] },
      },
      cities: [],
      currencyFormatter: new Intl.NumberFormat("it-IT", {
        style: "currency",
        currency: "EUR",
      }),

      floatFixFormatter: new Intl.NumberFormat("it-IT", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }),

      months: [
        "Gennaio",
        "Febbraio",
        "Marzo",
        "Aprile",
        "Maggio",
        "Giugno",
        "Luglio",
        "Agosto",
        "Settembre",
        "Ottobre",
        "Novembre",
        "Dicembre",
      ],

      route: {
        params: null,
      },

      id_offerta: 0,

      infoIsInEdit: false,
      oldInfo: null,

      provvigioniAgenteIsInEdit: false,
      oldProvvigioniAgente: null,

      ridIsInEdit: false,
      oldRid: null,

      data: {
        allegato: {
          allowedType: ["pdf", "jpeg", "jpg", "png"],
          file: [],
          tipo: null,
          note: null,
        },
        newContatto: {
          exist: {},
          type_update: "single",
        },

        agenti: [],
        offerte: [],
        giorniScadenza: [],
        tipiAliquotaIva: [],
        tipiAllegato: [],
        tipiContrattoVendita: [],
        tipiFatturazione: [],
        tipiMetodoPagamentoCliente: [],
        tipiStatoContratto: [],
        motivazioniStatoContrattoKo: [],
        tipiRid: [],
        tipiPeriodoFatturazione: [],
        tipiAcquisizione: [],
        tipiSpedizione: [],
        item: {},
      },
      loadingCities: false,
      citiesInitialized: false,
    };
  },

  async mounted() {
    this.route.params = this.$route.params;
    // console.log('route-params', this.route.params)

    this.contrattiVenditaService = new ContrattiVenditaService(
      this.$http,
      this.$eventBus
    );
    this.getDettaglioContrattoVendita(this.route.params.id);

    this.utilityService = new UtilityService(this.$http, this.$eventBus);
    this.getAgenti();
    this.getListaOfferte();
    this.getGiorniScadenza();
    this.getTipiAliquotaIva();
    this.getTipiContrattoVendita();
    this.getTipiFatturazione();
    this.getTipiMetodoPagamentoCliente();
    this.getTipiRid();
    this.getTipiPeriodoFatturazione();
    this.getTipiAcquisizione();
    this.getTipiSpedizione();
    this.getTipiAllegato();
    this.geTipiStatoContratto();
    this.geMotivazioniStatoContrattoKo();    
    this.filterToponimi();

    this.utilityContrattiVenditaService = new UtilityContrattiVenditaService(
      this.$http,
      this.$eventBus
    );
    this.checkRcuService = new CheckRcuService(this.$eventBus);

    await this.initializeCities();
  },

  methods: {
    async loadStoricoCambiContatto() {
      const id = this.data.item.id;
      if (!id || this.storicoCambiContattoLoading) return;
      this.storicoCambiContattoLoading = true;
      this.storicoCambiContattoError = '';
      try {
        this.storicoCambiContatto = await new CambioRappresentanteService(this.$http).storicoCambiContatto(id);
        this.storicoCambiContattoLoadedId = id;
      } catch (error) {
        this.storicoCambiContattoError = 'Impossibile caricare lo storico dei cambi contatto.';
      } finally {
        this.storicoCambiContattoLoading = false;
      }
    },
    isRepresentativeContact(contact) {
      return Number(contact?.rappresentante_id ?? contact?.cod_rapp ?? 0) > 0;
    },

    contactOwnerLabel(contact) {
      return this.isRepresentativeContact(contact)
        ? `Contatto del rappresentante: ${contact.rappresentante_name || 'Nome non disponibile'}`
        : 'Contatto del cliente';
    },

    contactAddressLabel(contact) {
      const street = [contact?.toponimo, contact?.indirizzo, contact?.civico]
        .filter(Boolean)
        .join(' ');
      const city = [contact?.cap, contact?.comune, contact?.provincia]
        .filter(Boolean)
        .join(' ');
      return [street, city].filter(Boolean).join(' - ') || 'Indirizzo non disponibile';
    },

    contactDisplayValue(value) {
      return value === null || value === undefined || String(value).trim() === ''
        ? 'Mancante'
        : value;
    },

    contactDropdownLabel(contact) {
      return [
        this.contactOwnerLabel(contact),
        this.contactAddressLabel(contact),
        contact?.email,
        contact?.pec,
        contact?.cell,
      ].filter(Boolean).join(' ');
    },

    normalizeDuplicateContactText(value) {
      return String(value ?? '').trim().replace(/\s+/g, ' ').toLocaleUpperCase('it-IT');
    },

    normalizeDuplicateContactPhone(value) {
      return String(value ?? '').replace(/[\s-]/g, '');
    },

    isContactPecBypassActive(contact) {
      const bypass = contact?.bypass_pec;
      return bypass && typeof bypass === 'object'
        ? bypass.value === true || Number(bypass.value) === 1
        : Number(bypass) === 1;
    },

    markDuplicateContacts(contacts) {
      const canonicalByPec = new Map();
      const canonicalByBypass = new Map();

      return [...contacts]
        .sort((first, second) => Number(first.id) - Number(second.id))
        .map((contact) => {
          const baseKey = JSON.stringify([
            this.normalizeDuplicateContactText(contact.toponimo),
            this.normalizeDuplicateContactText(contact.indirizzo),
            this.normalizeDuplicateContactText(contact.civico),
            this.normalizeDuplicateContactText(contact.cap),
            this.normalizeDuplicateContactText(contact.cod_comune),
            this.normalizeDuplicateContactPhone(contact.cellulare || contact.cell),
            this.normalizeDuplicateContactPhone(contact.telefono || contact.tel),
            this.normalizeDuplicateContactPhone(contact.fax),
            Number(contact.cod_rapp || 0),
            this.normalizeDuplicateContactText(contact.email),
          ]);
          const pecKey = `${baseKey}|PEC|${this.normalizeDuplicateContactText(contact.pec)}`;
          const bypassKey = this.isContactPecBypassActive(contact) ? `${baseKey}|BYPASS|1` : null;
          const canonical = canonicalByPec.get(pecKey)
            || (bypassKey ? canonicalByBypass.get(bypassKey) : null);

          if (!canonical) {
            canonicalByPec.set(pecKey, contact);
            if (bypassKey) canonicalByBypass.set(bypassKey, contact);
          }

          return {
            ...contact,
            duplicate_of: canonical?.id ?? null,
            disabled_duplicate: Boolean(canonical),
          };
        });
    },

    newContactForDuplicateCheck(oldCodRapp) {
      return {
        ...this.createNewContactCliente,
        cod_comune: this.createNewContactCliente.comune,
        tel: this.createNewContactCliente.telefono,
        cell: this.createNewContactCliente.cellulare,
        cod_rapp: oldCodRapp ?? 0,
      };
    },

    contactDuplicatePecKey(contact) {
      const baseKey = JSON.stringify([
        this.normalizeDuplicateContactText(contact.toponimo),
        this.normalizeDuplicateContactText(contact.indirizzo),
        this.normalizeDuplicateContactText(contact.civico),
        this.normalizeDuplicateContactText(contact.cap),
        this.normalizeDuplicateContactText(contact.cod_comune),
        this.normalizeDuplicateContactPhone(contact.cellulare || contact.cell),
        this.normalizeDuplicateContactPhone(contact.telefono || contact.tel),
        this.normalizeDuplicateContactPhone(contact.fax),
        Number(contact.cod_rapp || 0),
        this.normalizeDuplicateContactText(contact.email),
      ]);
      return `${baseKey}|PEC|${this.normalizeDuplicateContactText(contact.pec)}`;
    },

    findExistingContactForCreation(oldCodRapp) {
      const newContactKey = this.contactDuplicatePecKey(this.newContactForDuplicateCheck(oldCodRapp));
      return (this.data.item.contattiall || []).find(
        (contact) => this.contactDuplicatePecKey(contact) === newContactKey
      ) || null;
    },

    showDuplicateNewContactDialog(contact) {
      this.duplicateNewContactDialog = {
        visible: true,
        contact,
      };
    },

    openChangeContactFromDuplicate() {
      const reportedContact = this.duplicateNewContactDialog.contact;
      const duplicateContact = (this.data.item.contattiall || []).find(
        (contact) => String(contact.id) === String(reportedContact?.id)
      ) || reportedContact;
      const selectableContact = duplicateContact?.disabled_duplicate
        ? (this.data.item.contattiall || []).find(
          (contact) => String(contact.id) === String(duplicateContact.duplicate_of)
        )
        : duplicateContact;

      this.data.newContatto.exist = selectableContact && !selectableContact.disabled_duplicate
        ? selectableContact
        : {};
      this.duplicateNewContactDialog.visible = false;
      this.dialogCreateNewContactCliente = false;
      this.resetCreateNewContactClienteForm();
      this.dialogNewContact = true;
    },

    otherContactContracts(contact) {
      const currentContractId = Number(this.data.item?.id);
      return (contact?.contratti || []).filter(
        (contratto) => Number(contratto.id) !== currentContractId
      );
    },

    hasOtherContactAssociations(contact) {
      return Boolean(
        this.otherContactContracts(contact).length || contact?.caricamenti?.length
      );
    },

    openContactAssociations(contact) {
      this.contactAssociationsDialog.contact = {
        ...contact,
        contratti: this.otherContactContracts(contact),
      };
      this.contactAssociationsDialog.visible = true;
    },

    contractDetailUrl(contratto) {
      return `/ask/contratti/vendita/${encodeURIComponent(contratto.id)}/dettagli`;
    },

    contractChipClass(contratto) {
      if (Number(contratto.active) === 0) return "contract-chip-inactive";
      if (Number(contratto.cod_type_state) === 1) return "contract-chip-active";
      if (Number(contratto.cod_type_state) !== 0) return "contract-chip-warning";
      return "contract-chip-neutral";
    },

    contractTooltip(contratto) {
      const state = contratto.type_state_name || "Stato non disponibile";
      return Number(contratto.active) === 1 &&
        Number(contratto.cod_type_state) !== 1 &&
        Number(contratto.cod_type_state) !== 0
        ? `${contratto.label} · ${state}`
        : state;
    },

    sortedContactContracts(contratti) {
      const order = {
        "contract-chip-active": 0,
        "contract-chip-warning": 1,
        "contract-chip-neutral": 2,
        "contract-chip-inactive": 3,
      };
      return [...(contratti || [])].sort(
        (a, b) => order[this.contractChipClass(a)] - order[this.contractChipClass(b)]
      );
    },

    resetCreateNewContactClienteForm() {
      this.createNewContactCliente = {
        toponimo: null,
        indirizzo: "",
        civico: "",
        cap: "",
        comune: null,
        telefono: "",
        cellulare: "",
        fax: "",
        pec: "",
        email: "",
      };
    },

    editField(contactId, fieldName, fieldValue) {
      this.editingField = `${fieldName}-${contactId}`;
      this.newFieldValue = fieldValue;
    },
    cancelEdit() {
      this.editingField = null;
      this.newFieldValue = "";
    },
    getNameFromId(id) {
      const selectedOption = this.toponimi.find((item) => item.id === id);
      return selectedOption ? selectedOption.name : null;
    },

    async saveField(contactId, fieldName, newValue) {
      try {
        const contactIndex = this.data.item.contatti.findIndex(
          (contact) => contact.id === contactId
        );

        if (contactIndex === -1) {
          this.$toast.add({
            severity: "error",
            summary: "Errore",
            detail: `Contatto con ID ${contactId} non trovato`,
            life: 3000,
          });
          return;
        }

        const response = await this.contrattiVenditaService.updateContactField(
          contactId,
          fieldName,
          newValue
        );

        if (response.success) {
          const updatedContact = { ...this.data.item.contatti[contactIndex] };

          if (fieldName === 'comune') {
            const selectedCity = this.cities.find(city => city.id === newValue);
            if (selectedCity) {
              updatedContact.comune = selectedCity.name.split(' (')[0];
              updatedContact.provincia = selectedCity.name.match(/\((.*?)\)/)[1];
            }
          } else {
            updatedContact[fieldName] = newValue;
          }

          this.data.item.contatti.splice(contactIndex, 1, updatedContact);

          this.$toast.add({
            severity: "success", 
            summary: "Successo",
            detail: `Dato Aggiornato con successo`,
            life: 3000,
          });
          setTimeout(() => {
            window.location.reload();
          }, 1000);

          this.$nextTick(() => {
            this.$forceUpdate();
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Errore",
            detail: `Errore durante l'aggiornamento di ${fieldName}`,
            life: 3000,
          });
        }
      } catch (error) {
        console.error('Errore durante il salvataggio:', error);
        this.$toast.add({
          severity: "error",
          summary: "Errore",
          detail: `Errore durante l'aggiornamento di ${fieldName}`,
          life: 3000,
        });
      } finally {
        this.cancelEdit();
      }
    },

    createNewContactClienteAction() {
      if (this.isValidCreateNewContactCliente) {
        const oldCodRapp =
          this.data.item.contatti && this.data.item.contatti.length > 0
            ? this.data.item.contatti[0].cod_rapp
            : null;

        const existingContact = this.findExistingContactForCreation(oldCodRapp);
        if (existingContact) {
          this.showDuplicateNewContactDialog(existingContact);
          return;
        }

        const payload = {
          codeContratto: this.data.item.info.code,
          oldCodRapp: oldCodRapp,
          newContatto: { ...this.createNewContactCliente },
        };

        console.log("Payload da inviare:", payload);

        this.contrattiVenditaService
          .createNewContattoCliente(
            payload.codeContratto,
            payload.newContatto,
            payload.oldCodRapp
          )
          .then(() => {
            this.$toast.add({
              severity: "success",
              summary: "Successo",
              detail: "Nuovo contatto cliente creato con successo",
              life: 3000,
            });

            this.getDettaglioContrattoVendita(this.data.item.id);

            this.dialogCreateNewContactCliente = false;
            this.resetCreateNewContactClienteForm();
          })
          .catch((err) => {
            if (err?.response?.status === 409 && err.response.data?.existingContact) {
              this.showDuplicateNewContactDialog(err.response.data.existingContact);
              return;
            }
            console.error("Errore nella creazione del contatto:", err);
            this.$toast.add({
              severity: "error",
              summary: "Errore",
              detail: "Errore nella creazione del contatto",
              life: 3000,
            });
          });
      } else {
        console.warn("Validazione fallita per il form");
      }
    },

    normalizeNewContactValue(value) {
      return String(value ?? "")
        .normalize("NFKC")
        .trim()
        .replace(/\s+/g, " ")
        .toLocaleUpperCase("it-IT");
    },

    hasNewContactValue(value) {
      return value !== null && value !== undefined && String(value).trim() !== "";
    },

    isValidNewContactEmail(value) {
      const email = String(value || "").trim();
      const parts = email.split("@");
      if (parts.length !== 2) return false;

      const [localPart, domain] = parts;
      if (!localPart || !domain || localPart.startsWith(".") || localPart.endsWith(".") || localPart.includes("..")) return false;
      if (!/^[A-Z0-9.!#$%&'*+/=?^_`{|}~-]+$/i.test(localPart)) return false;

      const domainParts = domain.split(".");
      if (domainParts.length < 2 || domainParts.some((part) => !part)) return false;
      if (!domainParts.slice(0, -1).every((part) => /^[A-Z0-9](?:[A-Z0-9-]{0,61}[A-Z0-9])?$/i.test(part))) return false;

      return /^[A-Z]{2,63}$/i.test(domainParts[domainParts.length - 1]);
    },

    isValidNewContactPec(value) {
      if (!this.hasNewContactValue(value)) return true;
      if (!this.isValidNewContactEmail(value)) return false;

      const tld = String(value).trim().split(".").pop().toLowerCase();
      return !["example", "invalid", "localhost", "local", "test"].includes(tld);
    },

    isValidNewContactMobile(value) {
      const rawMobile = String(value || "").trim();
      if (/[^\d\s_-]/.test(rawMobile)) return false;
      const mobile = rawMobile.replace(/\D/g, "");
      return /^3\d{8,9}$/.test(mobile)
        && !/(\d)\1{4}/.test(mobile)
        && !/^(\d)\1+$/.test(mobile)
        && !/^3(\d)\1+$/.test(mobile)
        && !["3123456789", "3234567890", "3987654321", "3098765432"].includes(mobile);
    },

    selectedCreateNewContactComune() {
      return this.cities.find(
        (comune) => String(comune.id) === String(this.createNewContactCliente.comune)
      ) || null;
    },

    getCreateNewContactCapSettings() {
      const comune = this.selectedCreateNewContactComune();
      const cap = this.normalizeNewContactValue(comune?.cap);
      const isWildcard = /^\d{3}XX$/.test(cap);
      const isFixed = /^\d{5}$/.test(cap);

      return {
        comune,
        cap,
        isWildcard,
        isFixed,
        prefix: isWildcard ? cap.slice(0, 3) : "",
        initialValue: isWildcard ? cap.slice(0, 3) : (isFixed ? cap : ""),
      };
    },

    onChangeCreateNewContactComune() {
      const settings = this.getCreateNewContactCapSettings();
      this.createNewContactCliente.cap = settings.comune ? settings.initialValue : "";
    },

    updateCreateNewContactCapSuffix(value) {
      const prefix = this.getCreateNewContactCapSettings().prefix;
      const suffix = String(value || "").replace(/\D/g, "").slice(0, 2);
      this.createNewContactCliente.cap = `${prefix}${suffix}`;
    },

    isCreateNewContactCapValid(cap, comune) {
      const value = this.normalizeNewContactValue(cap);
      const comuneCap = this.normalizeNewContactValue(comune?.cap);
      if (!/^\d{5}$/.test(value)) return false;
      if (/^\d{3}XX$/.test(comuneCap)) return value.startsWith(comuneCap.slice(0, 3));
      return /^\d{5}$/.test(comuneCap) && value === comuneCap;
    },

    getNewContactClienteValidationErrors() {
      const contact = this.createNewContactCliente;
      const errors = {};
      const comune = this.selectedCreateNewContactComune();
      const toponimo = this.normalizeNewContactValue(contact.toponimo);
      const validToponimo = toponimo && this.toponimi.some(
        (item) => this.normalizeNewContactValue(item.name) === toponimo
      );

      if (!validToponimo) errors.toponimo = "Il toponimo è obbligatorio e deve essere valido.";
      if (!this.hasNewContactValue(contact.indirizzo)) errors.indirizzo = "L’indirizzo è obbligatorio.";
      if (!this.hasNewContactValue(contact.civico)) errors.civico = "Il civico è obbligatorio.";
      if (!comune) errors.comune = "Il comune è obbligatorio e deve essere valido.";
      if (!this.isCreateNewContactCapValid(contact.cap, comune)) errors.cap = "Il CAP non è valido per il comune selezionato.";
      if (!this.isValidNewContactEmail(contact.email)) errors.email = "L’email è obbligatoria e deve avere un formato valido.";
      if (!this.isValidNewContactPec(contact.pec)) errors.pec = "La PEC, se presente, deve avere un formato valido.";
      if (!this.isValidNewContactMobile(contact.cellulare)) {
        errors.cellulare = "Il cellulare deve iniziare con 3, contenere 9 o 10 cifre e rispettare le regole sulle sequenze.";
      }

      return errors;
    },

    async initializeCities() {
      if (this.citiesInitialized) return;
      
      try {
        this.loadingCities = true;
        const response = await this.utilityService.getComuniConCap();
        
        if (response && response.items && Array.isArray(response.items)) {
          this.cities = response.items.map(item => ({
            ...item,
            label: `${item.name} (${item.provincia})`,
          }));
          this.citiesInitialized = true;
        } else {
          console.warn('Risposta non valida dal server per le città:', response);
          this.cities = [];
        }
      } catch (err) {
        console.error('Errore nel caricamento iniziale delle città:', err);
        this.$toast.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Impossibile caricare l\'elenco delle città.',
          life: 3000
        });
        this.cities = [];
      } finally {
        this.loadingCities = false;
      }
    },

    async filterCities(event) {
      const query = event.query.toLowerCase();
      
      if (this.citiesInitialized) {
        if (query.length === 2) {
          try {
            this.loadingCities = true;
            const response = await this.contrattiVenditaService.getCities(query);
            
            if (response && response.items && Array.isArray(response.items)) {
              this.cities = response.items.map(item => ({
                ...item,
                label: `${item.name} (${item.provincia})`,
              }));
            }
          } catch (err) {
            console.error('Errore nella ricerca per provincia:', err);
          } finally {
            this.loadingCities = false;
          }
        } else {
          const allCities = [...this.cities];
          this.cities = allCities.filter(city => 
            city.label.toLowerCase().includes(query)
          );
        }
      } else {
        await this.initializeCities();
      }
    },

    async filterToponimi() {
      try {
        const response = await this.contrattiVenditaService.getToponimi();
        if (response && response.items) {
          this.toponimi = response.items.map((item) => ({
            name: item.name,
            id: item.id,
          }));
        }
      } catch (err) {
        console.error("Errore nel caricamento dei toponimi:", err);
        this.$toast.add({
          severity: "error",
          summary: "Errore",
          detail: "Impossibile caricare i toponimi.",
          life: 3000,
        });
      }
    },

    associaListino() {
      // console.log(this.data.item.info.cod_offerta)
    },
    getDettaglioContrattoVendita(id) {
      this.loader = true;
      this.contrattiVenditaService
        .getDettaglioContrattoVendita(id)
        .then((res) => {
          res.item.fatture?.dettagli?.map((el) => {
            el.saldo = el.importo - el.pagato;
            el.stato = el.saldo == 0 ? "Chiuso" : "Aperto";
          });

          this.data.item = res.item;
          if (this.storicoCambiContattoLoadedId === Number(id)) {
            this.storicoCambiContattoLoadedId = null;
            this.loadStoricoCambiContatto();
          }
          document.title =
            "info" in this.data.item
              ? "code" in this.data.item.info
                ? document.title + " - " + this.data.item.info.code
                : document.title
              : document.title;

          this.id_offerta = this.data.item.info.cod_offerta;

          this.data.item.contattiall = this.markDuplicateContacts(this.data.item.contattiall || [])
            .filter((el) => el.id != this.data.item.info.cod_contatto)
            .map((contact) => ({
              ...contact,
              dropdown_label: this.contactDropdownLabel(contact),
            }));
        })
        .finally(() => {
          this.loader = false;
        });
    },

    getAgenti() {
      this.utilityService.getAgenti().then((res) => {
        res.items.unshift({
          id: -1,
          name: "Nessuno",
        });

        this.data.agenti = res.items;
      });
    },

    getListaOfferte() {
      this.utilityService.getListaOfferte().then((res) => {
        res.items.unshift({
          id: -1,
          name: "Nessuno",
        });
        this.data.offerte = res.items;
      });
    },

    getTipiAliquotaIva() {
      this.utilityService.getTipiAliquotaIva().then((res) => {
        res.items.unshift({
          id: -1,
          name: "Nessuno",
        });

        this.data.tipiAliquotaIva = res.items;
      });
    },

    getTipiAllegato() {
      this.utilityService.getTipiAllegato().then((res) => {
        this.data.tipiAllegato = res.items;
      });
    },

    getGiorniScadenza() {
      this.utilityService.getGiorniScadenza().then((res) => {
        res.items.unshift({
          id: -1,
          name: "Nessuno",
        });

        this.data.giorniScadenza = res.items;
      });
    },

    getTipiContrattoVendita() {
      this.utilityService.getTipiContrattoVendita().then((res) => {
        res.items.unshift({
          id: -1,
          name: "Nessuno",
        });

        this.data.tipiContrattoVendita = res.items;
      });
    },

    getTipiFatturazione() {
      this.utilityService.getTipiFatturazione().then((res) => {
        res.items.unshift({
          id: -1,
          name: "Nessuno",
        });

        this.data.tipiFatturazione = res.items;
      });
    },

    getTipiMetodoPagamentoCliente() {
      this.utilityService.getTipiMetodoPagamentoCliente().then((res) => {
        res.items.unshift({
          id: -1,
          name: "Nessuno",
        });

        this.data.tipiMetodoPagamentoCliente = res.items;
      });
    },

    getTipiRid() {
      this.utilityService.getTipiRid().then((res) => {
        res.items.unshift({
          id: -1,
          name: "Nessuno",
        });

        this.data.tipiRid = res.items;
      });
    },

    getTipiPeriodoFatturazione() {
      this.utilityService.getTipiPeriodoFatturazione().then((res) => {
        res.items.unshift({
          id: -1,
          name: "Nessuno",
        });

        this.data.tipiPeriodoFatturazione = res.items;
      });
    },

    getTipiAcquisizione() {
      this.utilityService.getTipiAcquisizione().then((res) => {
        res.items.unshift({
          id: -1,
          name: "Nessuno",
        });

        this.data.tipiAcquisizione = res.items;
      });
    },

    getTipiSpedizione() {
      this.utilityService.getTipiSpedizione().then((res) => {
        res.items.unshift({
          id: -1,
          name: "Nessuno",
        });

        this.data.tipiSpedizione = res.items;
      });
    },

    geTipiStatoContratto() {
      this.utilityService.geTipiStatoContratto().then((res) => {
        // res.items.unshift({
        //   id: -1,
        //   name: 'Nessuno'
        // })

        this.data.tipiStatoContratto = res.items;
      });
    },

    geMotivazioniStatoContrattoKo() {
      this.utilityService.geMotivazioniStatoContrattoKo().then((res) => {
        res.items.unshift({
          id: -1,
          name: "Nessuno",
        });

        this.data.motivazioniStatoContrattoKo = res.items;
      });
    },

    downloadDocumenti(item) {
      this.loader = true;
      this.utilityService.downloadDocumenti(item).finally(() => {
        this.loader = false;
      });
    },

    openDocumenti(item) {
      this.loader = true;
      this.utilityService.openDocumenti(item).finally(() => {
        this.loader = false;
      });
    },
    openDocumento_wizard(id_matrice, filename) {
      this.loader = true;
      this.utilityService
        .viewDocumento_wizard(id_matrice, filename)
        .then((res) => {
          let pdfContents = res.item;
          pdfContents.forEach((pdf) => {
            const pdfContent = pdf[0];
            const pdfType = pdf[1];

            const decodedData = Uint8Array.from(atob(pdfContent), (c) =>
              c.charCodeAt(0)
            );
            const blob = new Blob([decodedData], { type: pdfType });
            const pdfUrl = URL.createObjectURL(blob);

            window.open(pdfUrl);
          });
        })
        .finally(() => {
          this.loader = false;
        });
    },
    downloadDocumento_wizard(id_matrice, filename) {
      this.loader = true;
      this.utilityService
        .downloadDocumento_wizard(id_matrice, filename)
        .finally(() => {
          this.loader = false;
        });
    },
    handleFileUpload(event) {
      this.data.allegato.file = [];
      this.data.allegato.file = event.target.files;
    },
    uploadDocumenti() {
      this.submitted = true;
      if (this.validateToUpload()) {
        this.loader = true;
        let fd = new FormData();
        for (let i = 0; i < this.data.allegato.file.length; i++) {
          fd.append("files[]", this.data.allegato.file[i]);
        }
        fd.append("id", this.data.item.id);
        fd.append("obj", "contratto");
        fd.append("tipo", this.data.allegato.tipo);
        fd.append("note", this.data.allegato.note);

        this.utilityService
          .uploadDocumenti(fd)
          .then(() => {
            this.getDettaglioContrattoVendita(this.data.item.id);
          })
          .finally(() => {
            this.loader = false;
          });
      }
    },
    validateToUpload() {
      this.validationErrors = {};

      if (!this.data.allegato.tipo) {
        this.validationErrors["tipo"] = true;
      } else {
        delete this.validationErrors["tipo"];
      }

      if (this.data.allegato.file.length == 0) {
        this.validationErrors["files"] = true;
      } else {
        delete this.validationErrors["files"];
      }

      if (this.data.allegato.file.length > 0) {
        let valid = [...this.data.allegato.file].every(
          (file) =>
            this.data.allegato.allowedType.includes(
              file.type.replace(/(.*)\//g, "")
            ),
          false
        );
        if (valid) delete this.validationErrors["type"];
        else this.validationErrors["type"] = true;
      }

      return !Object.keys(this.validationErrors).length;
    },

    onEditInfo() {
      this.oldInfo = JSON.stringify(this.data.item.info);

      this.infoIsInEdit = !this.infoIsInEdit;
    },

    onAbortInfoEdit() {
      this.data.item.info = JSON.parse(this.oldInfo);

      this.oldInfo = null;
      this.infoIsInEdit = !this.infoIsInEdit;
    },
    changeNode() {
      let key = String(Object.keys(this.data.item.key)[0]);

      this.data.item.info.cod_agente_firmatario = this.trovaSottolivello(
        this.data.item.sottoAgenti[0],
        key
      );
    },
    trovaSottolivello(oggetto, keyCercata) {
      // Se l'oggetto corrente ha la key cercata, restituisci il suo id

      if (oggetto.key && oggetto.key == keyCercata) {
        return oggetto.id;
      }

      // Se ha sottolivelli, scorrili ricorsivamente
      if (oggetto.children && Array.isArray(oggetto.children)) {
        for (let sottolivello of oggetto.children) {
          let risultato = this.trovaSottolivello(sottolivello, keyCercata);

          if (risultato !== null) {
            return risultato; // Restituisci l'id trovato
          }
        }
      }

      // Se non trovi nulla, restituisci null
      return null;
    },
    getScalaAgenti() {
      this.loader = false;

      this.data.item.key = { "": true };
      this.utilityService
        .getScalaAgenti(this.data.item.info.cod_agente)
        .then((res) => {
          this.data.item.sottoAgenti = res.item;
          if (this.data.item.sottoAgenti && this.data.item.sottoAgenti[0]) {
            this.data.item.key = { 0: true };
          }
          this.changeNode();
        })
        .finally(() => {
          this.loader = false;
        });
    },
    onUpdateInfo() {
      const allowed = [
        "data_firma",
        "data_inizio",
        "data_fine",
        "note",
        "cod_agente",
        "cod_type_contratto",
        "cod_type_spedizione",
        "cod_type_pay",
        "cod_type_iva",
        "cod_type_fatturazione",
        "cod_type_periodo",
        "cod_type_scadenza",
        "cod_offerta",
        "stato",
        "motivazione_stato",
        "motivazione_stato_testo",
        "cod_agente_firmatario",
      ];

      const info = Object.keys(this.data.item.info)
        .filter((key) => allowed.includes(key))
        .reduce((obj, key) => {
          return {
            ...obj,
            [key]: this.data.item.info[key],
          };
        }, {});

      if (info.cod_agente == -1) {
        info.cod_agente = null;
      }
      if (info.cod_type_contratto == -1) {
        info.cod_type_contratto = null;
      }
      if (info.cod_type_spedizione == -1) {
        info.cod_type_spedizione = null;
      }
      if (info.cod_type_pay == -1) {
        info.cod_type_pay = null;
      }
      if (info.cod_type_iva == -1) {
        info.cod_type_iva = null;
      }
      if (info.cod_type_fatturazione == -1) {
        info.cod_type_fatturazione = null;
      }
      if (info.cod_type_periodo == -1) {
        info.cod_type_periodo = null;
      }
      if (info.cod_type_scadenza == -1) {
        info.cod_type_scadenza = null;
      }
      if (info.cod_offerta == -1) {
        info.cod_offerta = null;
      }

      if (info.stato != 0) {
        info.motivazione_stato = null;
        info.motivazione_stato_testo = "";
      }

      if (this.oldInfo != JSON.stringify(this.data.item.info)) {
        this.contrattiVenditaService
          .updateInfo(this.data.item.id, info)
          .then((res) => {
            // console.log('UPDATED', res)
            if (res.success) {
              delete res.item.id;

              this.data.item.info = res.item;
            }
          });
      }

      this.oldInfo = null;
      this.infoIsInEdit = !this.infoIsInEdit;
    },

    onEditRid() {
      this.oldRid = JSON.stringify(this.data.item.provvigioni_agente);

      this.ridIsInEdit = !this.ridIsInEdit;
    },

    onAbortRidEdit() {
      this.data.item.rid = JSON.parse(this.oldRid);

      this.oldRid = null;
      this.ridIsInEdit = !this.ridIsInEdit;
    },

    onUpdateRid() {
      const allowed = [
        "data_firma_rid",
        "iban",
        "intestazione",
        "tipo_mandato",
        "istituto",
        "cfintestazione",
        "cod_type_rid",
      ];

      const rid = Object.keys(this.data.item.rid)
        .filter((key) => allowed.includes(key))
        .reduce((obj, key) => {
          return {
            ...obj,
            [key]: this.data.item.rid[key],
          };
        }, {});

      if (rid.cod_type_rid == -1) {
        rid.cod_type_rid = null;
      }

      if (this.oldRid != JSON.stringify(this.data.item.rid)) {
        this.contrattiVenditaService
          .updateRid(this.data.item.id, rid)
          .then((res) => {
            // console.log('UPDATED', res)
            if (res.success) {
              this.data.item.rid = res.item;
            }
          });
      }

      this.oldRid = null;
      this.ridIsInEdit = !this.ridIsInEdit;
    },

    onEditProvvigioniAgente() {
      this.oldProvvigioniAgente = JSON.stringify(
        this.data.item.provvigioni_agente
      );

      this.provvigioniAgenteIsInEdit = !this.provvigioniAgenteIsInEdit;
    },

    onAbortProvvigioniAgenteEdit() {
      this.data.item.provvigioni_agente = JSON.parse(this.oldProvvigioniAgente);

      this.oldProvvigioniAgente = null;
      this.provvigioniAgenteIsInEdit = !this.provvigioniAgenteIsInEdit;
    },

    onUpdateProvvigioniAgente() {
      const allowed = [
        "cod_agente",
        "ric_mens",
        "ric_cons",
        "giorni_ric",
        "gettone1_consumo",
        "gettone1",
        "giorni_gettone1",
        "gettone1_stornabile",
        "gettone2_consumo",
        "gettone2",
        "giorni_gettone2",
        "gettone2_stornabile",
        "gettone3_consumo",
        "gettone3",
        "giorni_gettone3",
        "gettone3_stornabile",
      ];

      const provvigioniAgente = Object.keys(this.data.item.provvigioni_agente)
        .filter((key) => allowed.includes(key))
        .reduce((obj, key) => {
          return {
            ...obj,
            [key]: this.data.item.provvigioni_agente[key],
          };
        }, {});

      if (provvigioniAgente.cod_agente == -1) {
        provvigioniAgente.cod_agente = null;
      }

      if (
        this.oldProvvigioniAgente !=
        JSON.stringify(this.data.item.provvigioni_agente)
      ) {
        this.contrattiVenditaService
          .updateProvvigioniAgente(this.data.item.id, provvigioniAgente)
          .then((res) => {
            // console.log('UPDATED', res)
            if (res.success) {
              this.data.item.provvigioni_agente = res.item;
            }
          });
      }

      this.oldProvvigioniAgente = null;
      this.provvigioniAgenteIsInEdit = !this.provvigioniAgenteIsInEdit;
    },
    sendClientLoginEmail(email) {
      this.loader = true;
      this.contrattiVenditaService
        .sendClientLoginEmail(this.data.item.info.cliente, email)
        .then((res) => {
          if (res.item.status) {
            this.$toast.add({
              severity: "success",
              summary: "Successo",
              detail: "Email inviata",
              life: 3000,
            });
            this.updateClientiAccessDate(email);
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Errore",
              detail: "Errore nell'invio della email",
              life: 3000,
            });
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },
    updateClientiAccessDate(email) {
      this.loader = true;
      this.contrattiVenditaService
        .updateClientiAccessDate(email)
        .then((res) => {
          if (res.success) {
            this.getDettaglioContrattoVendita(this.data.item.id);
          } else {
            this.$toast.add({
              severity: "error",
              summary: "Errore",
              detail: "Errore update dati accesso",
              life: 3000,
            });
          }
        })
        .finally(() => {
          this.loader = false;
        });
    },
    onAggiungiPod(/** event **/) {
      window.open(
        `${wizard.url}/forniture-ee/step.pod/${this.route.params.id}/${this.data.item.info.cod_cliente}`,
        "_blank"
      );
    },
    onAggiungiPodsMassivo(/** event **/) {
      this.dialogPodsMassivo = true;
    },
    handleCsvUpload(evt) {
      this.fileCsv = [];
      evt.preventDefault();
      this.submitted = false;
      this.fileCsv = this.$refs.file.files;
    },

    createPodsMassivo() {
      this.submitted = true;
      if (this.validateFile()) {
        this.contrattiVenditaService
          .createPodsMassivo(this.route.params.id, this.fileCsv)
          .then((res) => {
            console.log("RES", res);
          });
      }
    },
    validateFile() {
      if (this.fileCsv.length == 0) {
        this.validationErrors["files"] = true;
        delete this.validationErrors["type"];
      } else {
        delete this.validationErrors["files"];
      }

      if (this.fileCsv.length > 0) {
        let valid = [...this.fileCsv].every(
          (file) => ["text/csv"].includes(file.type),
          false
        );
        if (valid) delete this.validationErrors["type"];
        else this.validationErrors["type"] = true;
      }

      return !Object.keys(this.validationErrors).length;
    },
    updateNewContact() {
      if ("id" in this.data.newContatto.exist) {
        this.loader = true;
        this.contrattiVenditaService
          .updateNewContact(
            this.data.item.id,
            this.data.newContatto,
            this.data.item.contatti[0]
          )
          .then((res) => {
            this.getDettaglioContrattoVendita(this.data.item.id);
            this.$toast.add({
              severity: "success",
              summary: "Successo",
              detail: `${res.item} contatto/i modificato/i`,
              life: 3000,
            });
          })
          .finally(() => {
            this.loader = false;
          });
      } else {
        this.$toast.add({
          severity: "warn",
          summary: "Attenzione",
          detail: "Nuovo contatto non selezionato",
          life: 3000,
        });
      }
    },
    onAggiungiPdr(/** event **/) {
      window.open(
        `${wizard.url}/forniture-gas/step.pdr/${this.route.params.id}/${this.data.item.info.cod_cliente}`,
        "_blank"
      );
    },

    onEsportaMandatoRid(/** event **/) {
      this.utilityContrattiVenditaService.downloadMandatiRidMpsZip({
        "contratto_vendita.ids": [this.route.params.id],
      });
    },

    onClonaContratto(/** event **/) {
      window.open(
        `${wizard.url}/contratto/step-associa/${this.data.item.info.cod_cliente}/${this.route.params.id}`,
        "_blank"
      );
    },
    onDownloadSeda(/** event **/) {
      this.checkRcuService.exportRecord(this.data.item.id);
    },

    // cancelEdit() {
    //   this.editingEmail = null;
    //   this.newEmail = "";
    // },
  },

  computed: {
    isCreateNewContactDisabled() {
      if (!this.data.item || !this.data.item.contatti || !Array.isArray(this.data.item.contatti)) {
        return false;
      }

      return this.data.item.contatti.some((contact) => {
        return (
          contact &&
          (contact.toponimo ||
            contact.indirizzo ||
            contact.civico ||
            contact.cap ||
            contact.comune ||
            contact.tel ||
            contact.cell ||
            contact.fax ||
            contact.pec ||
            contact.email)
        );
      });
    },
    combinedData() {
      const combinedRow = {
        cliente:
          this.data.item.info?.cliente ||
          this.data.item.contatti?.[0]?.cliente ||
          "N/A",
        codfis:
          this.data.item.info?.codfis ||
          this.data.item.contatti?.[0]?.codfis ||
          "N/A",
        toponimo:
          this.data.item.info?.toponimo ||
          this.data.item.contatti?.[0]?.toponimo ||
          "",
        indirizzo:
          this.data.item.info?.indirizzo ||
          this.data.item.contatti?.[0]?.indirizzo ||
          "",
        civico:
          this.data.item.info?.civico ||
          this.data.item.contatti?.[0]?.civico ||
          "",
        cap:
          this.data.item.info?.cap || this.data.item.contatti?.[0]?.cap || "",
        comune:
          this.data.item.info?.comune ||
          this.data.item.contatti?.[0]?.comune ||
          "",
        provincia:
          this.data.item.info?.provincia ||
          this.data.item.contatti?.[0]?.provincia ||
          "",
      };
      return [combinedRow];
    },

    dataFirma: {
      get: function () {
        return this.data.item.info.data_firma !== null &&
          this.data.item.info.data_firma !== ""
          ? moment(this.data.item.info.data_firma).format("DD/MM/YYYY")
          : null;
      },
      set: function (value) {
        if (value instanceof Date && !isNaN(value.valueOf())) {
          this.data.item.info.data_firma = moment(value).format("YYYY-MM-DD");
        }

        if (value === null || value === "") {
          this.data.item.info.data_firma = null;
        }
      },
    },

    dataInizio: {
      get: function () {
        return this.data.item.info.data_inizio !== null &&
          this.data.item.info.data_inizio !== ""
          ? moment(this.data.item.info.data_inizio).format("DD/MM/YYYY")
          : null;
      },
      set: function (value) {
        if (value instanceof Date && !isNaN(value.valueOf())) {
          this.data.item.info.data_inizio = moment(value).format("YYYY-MM-DD");
        }

        if (value === null || value === "") {
          this.data.item.info.data_inizio = null;
        }
      },
    },

    dataFine: {
      get: function () {
        return this.data.item.info.data_fine !== null &&
          this.data.item.info.data_fine !== ""
          ? moment(this.data.item.info.data_fine).format("DD/MM/YYYY")
          : null;
      },
      set: function (value) {
        if (value instanceof Date && !isNaN(value.valueOf())) {
          this.data.item.info.data_fine = moment(value).format("YYYY-MM-DD");
        }

        if (value === null || value === "") {
          this.data.item.info.data_fine = null;
        }
      },
    },

    dataFirmaRid: {
      get: function () {
        return this.data.item.rid.data_firma_rid !== null &&
          this.data.item.rid.data_firma_rid !== ""
          ? moment(this.data.item.rid.data_firma_rid).format("DD/MM/YYYY")
          : null;
      },
      set: function (value) {
        if (value instanceof Date && !isNaN(value.valueOf())) {
          this.data.item.rid.data_firma_rid =
            moment(value).format("YYYY-MM-DD");
        }

        if (value === null || value === "") {
          this.data.item.rid.data_firma_rid = null;
        }
      },
    },

    isValidCreateNewContactCliente() {
      return Object.keys(this.newContactClienteValidationErrors).length === 0;
    },

    newContactClienteValidationErrors() {
      return this.getNewContactClienteValidationErrors();
    },

    newContactClienteValidationTooltip() {
      return this.isValidCreateNewContactCliente
        ? ""
        : Object.values(this.newContactClienteValidationErrors).join(" · ");
    },

    createNewContactCapSettings() {
      return this.getCreateNewContactCapSettings();
    },

    createNewContactCapSuffix() {
      const prefix = this.createNewContactCapSettings.prefix;
      const cap = String(this.createNewContactCliente.cap || "");
      return cap.startsWith(prefix) ? cap.slice(prefix.length, prefix.length + 2) : "";
    },

    contrattoSaldoResiduo() {
      const saldo = Number(this.data.item?.fatture?.saldo ?? 0);
      return !Number.isNaN(saldo) && saldo > 0 ? saldo : 0;
    },

    contrattoSupplyPoints() {
      const contrattoId = Number(this.data.item?.id);
      const pods = Array.isArray(this.data.item?.pods) ? this.data.item.pods : [];
      const pdrs = Array.isArray(this.data.item?.pdrs) ? this.data.item.pdrs : [];

      const belongsToContratto = (point) =>
        Number(point?.cod_contratto) === contrattoId;

      const podsFiltrati = contrattoId
        ? pods.filter(belongsToContratto)
        : pods;
      const pdrsFiltrati = contrattoId
        ? pdrs.filter(belongsToContratto)
        : pdrs;

      return [
        ...podsFiltrati
          .map((p) => ({
            id: p?.id || p?.cod_pod || null,
            type: "pod",
            code: p?.code || p?.pod || null,
          }))
          .filter((p) => p.id || p.code),
        ...pdrsFiltrati
          .map((p) => ({
            id: p?.id || p?.cod_pdr || null,
            type: "pdr",
            code: p?.code || p?.pdr || null,
          }))
          .filter((p) => p.id || p.code),
      ];
    },
  },
};
</script>

<style scoped>
.multicap-editor {
  display: flex;
  align-items: stretch;
  min-width: 8rem;
}

.multicap-prefix {
  display: inline-flex;
  align-items: center;
  padding: 0 0.65rem;
  border: 1px solid var(--surface-border);
  border-right: 0;
  border-radius: 6px 0 0 6px;
  background: var(--surface-100);
  color: var(--text-color-secondary);
  font-weight: 600;
}

.multicap-suffix {
  width: 4rem;
  border-radius: 0 6px 6px 0;
}

:global(.change-contact-dialog.p-dialog) {
  display: flex;
  flex-direction: column;
  height: 85vh;
  max-height: 85vh;
  background: var(--surface-overlay);
}

:global(.change-contact-dialog .p-dialog-header),
:global(.change-contact-dialog .p-dialog-content),
:global(.change-contact-dialog .p-dialog-footer) {
  background: var(--surface-overlay);
}

:global(.change-contact-dialog .p-dialog-content) {
  flex: 1 1 auto;
  min-height: 0;
}

.contact-details {
  display: grid;
  gap: 1rem;
}

.change-contact-option {
  display: grid;
  width: 100%;
  gap: 0.4rem;
  padding: 0.3rem 0;
  white-space: normal;
}

.change-contact-option-selected {
  padding: 0.15rem 0;
}

.change-contact-option-duplicate {
  opacity: 0.58;
}

.change-contact-duplicate-label {
  padding: 0.15rem 0.45rem;
  border-radius: 999px;
  background: #fef3c7;
  color: #92400e;
  font-size: 0.68rem;
  font-weight: 600;
}

.duplicate-new-contact-summary {
  display: grid;
  gap: 0.65rem;
  margin-top: 1rem;
  padding: 1rem;
  border: 1px solid var(--surface-border);
  border-radius: 6px;
  background: var(--surface-50);
}

.duplicate-new-contact-summary > div {
  display: grid;
  grid-template-columns: 7rem minmax(0, 1fr);
  gap: 0.75rem;
}

.duplicate-new-contact-summary span {
  color: var(--text-color-secondary);
}

.duplicate-new-contact-summary strong {
  overflow-wrap: anywhere;
}

.change-contact-option-header,
.change-contact-recapiti {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem 1rem;
}

.change-contact-option-header {
  justify-content: space-between;
}

.change-contact-owner {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.2rem 0.55rem;
  border-radius: 999px;
  background: #e0f2fe;
  color: #075985;
  font-size: 0.75rem;
  font-weight: 600;
}

.change-contact-owner-representative {
  background: #ede9fe;
  color: #5b21b6;
}

.change-contact-address {
  color: var(--text-color);
}

.change-contact-recapiti {
  color: var(--text-color-secondary);
  font-size: 0.78rem;
}

.change-contact-recapiti .pi {
  margin-right: 0.3rem;
}

.contact-data-section {
  padding: 1rem 1rem 0;
  border: 1px solid var(--surface-border);
  border-radius: 6px;
  background: var(--surface-50);
}

.contact-data-section h5 {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin: 0 0 1rem;
}

.contact-data-section label {
  display: block;
  margin-bottom: 0.35rem;
  color: var(--text-color-secondary);
  font-size: 0.8rem;
}

.association-chips,
.contract-status-legend {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.contract-status-legend {
  margin-bottom: 1rem;
  font-size: 0.75rem;
}

.contract-status-legend span {
  padding: 0.25rem 0.5rem;
  border-radius: 999px;
}

.contract-chip-legend {
  display: block;
  margin-bottom: 0.75rem;
  color: var(--text-color-secondary);
}

.contract-chip-legend .pi {
  margin-right: 0.4rem;
}

.contract-chip-link {
  color: inherit;
  text-decoration: none;
}

.contract-chip-link :deep(.contract-chip-active),
.contract-status-active {
  background: #dcfce7;
  color: #166534;
}

.contract-chip-link :deep(.contract-chip-warning),
.contract-status-warning {
  background: #fff1bd;
  color: #854d0e;
}

.contract-chip-link :deep(.contract-chip-inactive),
.contract-status-inactive {
  background: #fbe0e0;
  color: #991b1b;
}

.contract-chip-link :deep(.contract-chip-neutral),
.contract-status-neutral {
  background: #e9edf2;
  color: #475569;
}

</style>

